import { MarkdownViewer } from '@ardoq/markdown';
import { APIComponentAttributes } from '@ardoq/api-types';
import styled from 'styled-components';
import { Header5, text2 } from '@ardoq/typography';

const ScrollContainer = styled.div`
  max-height: 240px;
  overflow: auto;
  height: 100%;
  ${text2};
`;

type DescriptionProps = {
  component: APIComponentAttributes;
  title?: string;
};

const Description = ({
  component,
  title = 'Description',
}: DescriptionProps) => {
  if (!component.description) return null;

  return (
    <>
      <Header5>{title}</Header5>
      <ScrollContainer>
        <MarkdownViewer
          content={component.description}
          sanitationLevel="permissive"
        />
      </ScrollContainer>
    </>
  );
};

export { Description };
